var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.125a.875.875 0 0 1 0 1.75h-11a.875.875 0 0 1 0-1.75zM5 8c0-.471 0-.707.146-.854C5.293 7 5.53 7 6 7s.707 0 .854.146C7 7.293 7 7.53 7 8v3c0 .471 0 .707-.146.854C6.707 12 6.47 12 6 12s-.707 0-.854-.146C5 11.707 5 11.47 5 11zM9 4c0-.471 0-.707.146-.854C9.293 3 9.53 3 10 3s.707 0 .854.146C11 3.293 11 3.53 11 4v7c0 .471 0 .707-.146.854C10.707 12 10.47 12 10 12s-.707 0-.854-.146C9 11.707 9 11.47 9 11zM13 6c0-.471 0-.707.146-.854C13.293 5 13.53 5 14 5s.707 0 .854.146C15 5.293 15 5.53 15 6v5c0 .471 0 .707-.146.854C14.707 12 14.47 12 14 12s-.707 0-.854-.146C13 11.707 13 11.47 13 11z"
  })));
};
export default SvgAnalytics;